import { Card } from '@mui/material';
import { useNavigateToRoot } from 'hooks/useNavigateToRoot';
import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { CancelButton } from 'shared/mui/Buttons';
import { CardActionsButtons, CardHeader } from 'shared/mui/Card';
import { CardContent } from 'shared/mui/Card/CardContent/CardContent';
import { Dialog, DialogProps } from 'shared/mui/Dialogs/Dialog/Dialog';
import { CloseIconButton } from 'shared/mui/IconButtons';
import { Typography } from 'shared/mui/Typography';
import { TypographyBold } from 'shared/mui/Typography/TypographyBold';
import { Commission } from 'types/embedded/commission';
import { truncateString } from 'utils/truncateString';

type Props = {
  record: Commission | undefined;
  onBackClick?: () => void;
} & DialogProps;

export const CommissionsImplementErrorDialog: React.FC<Props> = ({
  record,
  onBackClick,
  ...restProps
}) => {
  const translate = useTypedTranslate();

  const { toRoot } = useNavigateToRoot();

  const onClose = () => {
    restProps.onClose();
  };

  return (
    <Dialog {...restProps} fullWidth width="640px">
      <Card>
        <CardHeader
          appendActions={[<CloseIconButton key="close-button" onClose={onClose} />]}
          title={translate('app.merchantCommissions.activateCommission')}
          titleSize="smallBold"
        />
        <CardContent>
          <Typography>
            {translate('app.merchantCommissions.activateCommissionError1')}{' '}
            <TypographyBold fontSize={16} text={truncateString(record?.name || '', 50)} />{' '}
            {translate('app.merchantCommissions.activateCommissionError2')}{' '}
          </Typography>
        </CardContent>
        <CardActionsButtons
          rightActionsSlot={[
            <CancelButton
              key="back-button"
              label={translate('app.merchantCommissions.backToList')}
              onClick={onBackClick || toRoot}
              variant="outlined"
            />,
          ]}
        />
      </Card>
    </Dialog>
  );
};
